"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const authenticated_client_1 = require("./authenticated.client");
class UserClient extends authenticated_client_1.AuthenticatedClient {
    getMyProjects(fields = ['id', 'name']) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v1/me/projects?${this.getQueryString({ fields })}`;
            const response = yield this.httpGet(url);
            return response.payload || [];
        });
    }
    getGdprStatus() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/me/gdpr`);
            return response.payload;
        });
    }
    acceptGdprV2() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPut(`/v2/me/gdpr-accept`);
            response.payload;
        });
    }
    getMyCustomers() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/me/customers`);
            return response.payload || [];
        });
    }
    getEmailAdministrators() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/me/administrators`);
            return response.payload || [];
        });
    }
    getProjectById(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/me/projects/${id}`);
            return response.payload;
        });
    }
    getMyProfile(fields) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/me?${this.getQueryString({ fields })}`);
            return response.payload;
        });
    }
    getMyCurrency() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/me?${this.getQueryString({ fields: ['currency'] })}`);
            const { currency } = response.payload;
            return currency;
        });
    }
    favorite(projectId, entity, entityId) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v1/me/projects/${projectId}/favorite/${entity}/${entityId}`;
            yield this.httpPost(url);
        });
    }
    unfavorite(projectId, entity, entityId) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v1/me/projects/${projectId}/favorite/${entity}/${entityId}`;
            yield this.httpDelete(url);
        });
    }
    getUserPreferences() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/me/preferences`);
            return response.payload;
        });
    }
    setUserPreferences(settings) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/me/preferences`, Object.assign({}, settings));
            return response.payload;
        });
    }
    getUserProjectPreferences(projectId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/me/projects/${projectId}/preferences`);
            return response.payload;
        });
    }
    getDareboostToken(projectId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/me/projects/${projectId}/tokens/dareboost`);
            return response.payload;
        });
    }
    setUserProjectPreferences(projectId, settings) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/me/projects/${projectId}/preferences`, Object.assign({}, settings));
            return response.payload;
        });
    }
    getUseRole(projectId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/me/projects/${projectId}/role`);
            return response.payload;
        });
    }
    acceptGdpr(acceptedVersion) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPut(`/v1/me/gdpr-accept/${acceptedVersion}`);
            return response.payload;
        });
    }
    updateUser(user) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPut(`/v1/me`, user);
            return response.payload;
        });
    }
}
exports.UserClient = UserClient;
//# sourceMappingURL=user.client.js.map